module.exports = __webpack_public_path__ + "img/home_hero1.png";